import { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Modal from '../../components/Modal'
import { Checkbox, CreatableSelect, Input } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createGradeOptions, updateGradeOptions } from '../../actions/directory'
import styles from './styles.module.scss'
import Confirmation from '../../components/Confirmation/Confirmation'

const validationSchema = Yup.object({
  value: Yup.string().required('обязательное поле'),
})

const VALUE_MAX_LENGTH = 20
const TEXT_MAX_LENGTH = 200

export default function GradesOptionsModal({ data, closeModal, height }) {
  const dispatch = useDispatch()

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])
  const { gradesOptions } = useSelector(state => state.directory)

  const addMode = !data?.value

  const [errorForCreatableSelect, setErrorForCreatableSelect] = useState(false)
  const [gradeValueInput, setGradeValueInput] = useState('')
  const [serverError, setServerError] = useState('')

  useEffect(() => {
    setServerError('')
    setGradeValueInput('')
    setErrorForCreatableSelect(false)
  }, [data])

  const handleValueInputChange = (newValue, { action }) => {
    if (action === 'input-change') {
      setGradeValueInput(newValue.slice(0, VALUE_MAX_LENGTH))
      setServerError('')
    } else {
      setGradeValueInput(newValue)
    }
  }

  const handleCreateGradeOptions = async (values) => {
    const forRequest = {
      ...values,
      isgrade: values.isgrade ? -1 : 0,
      isdisease: values.isdisease ? -1 : 0,
      closed: values.closed,
    }
    !values.value && setErrorForCreatableSelect(true)
    setServerError('')
    const result = await dispatch(createGradeOptions(forRequest))
    if (result.success) {
      closeModal()
    } else {
      setServerError(result.error)
    }
  }

  const handleUpdateGradeOptions = async (values) => {
    const forRequest = {
      ...values,
      isgrade: values.isgrade ? -1 : 0,
      isdisease: values.isdisease ? -1 : 0,
      closed: values.closed,
    }
    const result = await dispatch(updateGradeOptions(forRequest))
    result && closeModal()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    setFieldValue,
    handleSubmit
  } = useFormik({
    initialValues: addMode ? { value: '', text: '', isgrade: '', isdisease: '', closed: false } : data,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: addMode ? handleCreateGradeOptions : handleUpdateGradeOptions
  })

  const createOption = (label, dataId) => ({ label, value: dataId })
  const options = gradesOptions?.map(({ value, valid }) => createOption(value, valid))

  const handleChange2 = (value) => {
    setFieldValue('value', value ? value.label : '')
    setGradeValueInput('')
  }

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  return (
    <Modal open={!!data} height={height} onClose={handleClose} closeOnOverlayClick={true} closeOnEsc={true}>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsColumn}>
            <div style={{ position: 'relative', width: 'fit-content' }}>
              <CreatableSelect
                isClearable
                options={options}
                onChange={handleChange2}
                onInputChange={handleValueInputChange}
                inputValue={gradeValueInput}
                label='Значение'
                name='value'
                placeholder={values.value || "Выбрать"}
                error={error('value')}
              />
              {gradeValueInput.length > 0 && (
                <span
                  style={{ position: 'absolute', top: 0, right: 40 }}
                  className={gradeValueInput.length >= VALUE_MAX_LENGTH ? styles.charCounterWarn : styles.charCounter}
                >
                  {gradeValueInput.length >= VALUE_MAX_LENGTH
                    ? `Достигнут лимит ${VALUE_MAX_LENGTH} символов`
                    : `${gradeValueInput.length} / ${VALUE_MAX_LENGTH}`}
                </span>
              )}
              {serverError && (
                <p className={styles.serverError}>{serverError}</p>
              )}
            </div>
          </div>
          <div className={styles.inputsRow}>
            <div className={styles.fieldWithCounter}>
              <Input
                label='Примечание'
                name='text'
                value={values.text}
                error={error('text')}
                onChange={handleChange}
                maxLength={TEXT_MAX_LENGTH}
                style={{ width: '300px', lineHeight: '25px' }}
              />
              {(values.text?.length || 0) > 0 && (
                <span className={(values.text?.length || 0) >= TEXT_MAX_LENGTH ? styles.charCounterWarn : styles.charCounter}>
                  {(values.text?.length || 0) >= TEXT_MAX_LENGTH
                    ? `Достигнут лимит ${TEXT_MAX_LENGTH} символов`
                    : `${values.text.length} / ${TEXT_MAX_LENGTH}`}
                </span>
              )}
            </div>
          </div>
          {console.log('values::: ', values)}
          <div className={styles.inputsRow}>
            <Checkbox label='Это оценка' checked={!!values.isgrade} value={!!values.isgrade} onChange={handleChange} name='isgrade' />
            <Checkbox label='Отсутстве по болезни' checked={!!values.isdisease} value={!!values.isdisease} onChange={handleChange} name='isdisease' />
            <Checkbox label='Закрыт' checked={!!values.closed} value={!!values.closed} onChange={handleChange} name='closed' />
          </div>
        </div>
      </div>
      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}
